import { Advertiser, Dsp, Brand } from 'components/common/types/Deal.types';
import { CreativeStatus } from 'components/common/types/Creative.types';
import { CreativeType } from 'components/common/types';

export interface FilterTypes {
  dsp: Dsp | null;
  advertiser: Advertiser | null;
  brand: Brand | null;
  creativeType: string | null;
}

export interface SelectedCreativeTypes {
  id: string;
  previewUrl: string;
  status: CreativeStatus;
  thumbnailUrl: string;
  type: CreativeType;
}

export const creativeTypes = [
  {
    code: '',
    name: 'Select creative type',
  },
  {
    code: CreativeType.VIDEO,
    name: 'Video',
  },
  {
    code: CreativeType.BANNER,
    name: 'Banner',
  },
];
